/**
 * Client-side helper to construct CDN URLs for assets.
 * Reads from runtime config (overridable per-env via public/runtime-config.<EnvName>.js).
 */
import { config } from './config'

const CDN_URL = config.cdnUrl

export function getFileUrl(key) {
  return `${CDN_URL}/${key}`
}
